import { useEffect } from "react";
import { useAuth } from "../../hooks/use-auth";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Vérifie les permissions pour une liste de composants en un seul useEffect.
 * Accepte un string ou un tableau de strings.
 */
export const usePermissionRedirect = (componentNames) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    const tenant = globalThis.localStorage.getItem("tenant");
    const names = Array.isArray(componentNames) ? componentNames : [componentNames];
    const multiPermComponents = ["Actions", "EPP", "Liste des sessions", "Administrateurs"];

    for (const componentName of names) {
      const isAccessingCreate = path.includes(`/create/${componentName.toLowerCase()}`);
      const isAccessingList = path.endsWith(`/${componentName.toLowerCase()}`);

      if (isAccessingCreate) {
        const hasCreate = user.components_and_permissions.some(
          (p) => p.component === componentName && p.permission === "Créer"
        );
        if (!hasCreate) {
          navigate(`/${tenant}/404_not_found`);
          return;
        }
      } else if (isAccessingList) {
        if (multiPermComponents.includes(componentName)) {
          const hasAny = user.components_and_permissions.some(
            (p) => p.component === componentName && (p.permission === "Voir" || p.permission === "Créer")
          );
          if (!hasAny) {
            navigate(`/${tenant}/404_not_found`);
            return;
          }
        } else {
          const hasVoir = user.components_and_permissions.some(
            (p) => p.component === componentName && p.permission === "Voir"
          );
          if (!hasVoir) {
            navigate(`/${tenant}/404_not_found`);
            return;
          }
        }
      }
    }
  }, [location.pathname, user, navigate]);
};
